const translations = {
  "en": {
    "Score": "Score"
  },
  "zh-tw": {
    "Score": "得分"
  }
};

export default translations;
